<script setup>
/**
 * Mirrors Vue2's ShowMZList.vue: two separate summary tables sourced from
 * GET /api/bdvoucher/getMezSummary -> { voucherList, availableList }.
 * - voucherList: one row per entity, columns Entity/Available/Pending/
 *   Redeemed/Expired-Voided
 * - availableList: one row per voucher value, columns Voucher Value/
 *   Goldheart/Lee Hwa/Maxi-Cash (breakdown of available stock by entity)
 */
import { ref, onMounted } from "vue";
import AppDataTable from "@/components/AppDataTable.vue";
import { fetchMezzofySummary } from "./api";
import { useRouter } from "vue-router";

const router = useRouter();
const loading = ref(false);
const error = ref("");

const summaryColumns = [
  { key: "entity", label: "Entity", sortable: true },
  { key: "available", label: "Available" },
  { key: "pending", label: "Pending" },
  { key: "redeemed", label: "Redeemed" },
  { key: "void", label: "Expired/Voided" },
];
const summaryRows = ref([]);

const availableColumns = [
  { key: "value", label: "Voucher Value", sortable: true },
  { key: "Goldheart", label: "Goldheart" },
  { key: "Lee Hwa", label: "Lee Hwa" },
  { key: "Maxi-Cash", label: "Maxi-Cash" },
];
const availableRows = ref([]);

onMounted(async () => {
  loading.value = true;
  try {
    const { voucherList = [], availableList = [] } = await fetchMezzofySummary();
    summaryRows.value = voucherList.map((row, i) => ({ id: row.entity ?? i, ...row }));
    availableRows.value = availableList.map((row, i) => ({ id: row.value ?? i, ...row }));
  } catch { error.value = "Couldn't load Mezzofy summary."; }
  finally { loading.value = false; }
});
</script>

<template>
  <section>
    <div class="d-flex align-center justify-space-between mb-4 gap-3 flex-wrap">
      <h1 class="text-h5">Mezzofy Vouchers</h1>
      <VBtn variant="tonal" @click="router.push({ name: 'mezzofy-vouchers-upload' })">Upload Vouchers</VBtn>
    </div>
    <VAlert v-if="error" type="error" class="mb-4">{{ error }}</VAlert>

    <h2 class="text-subtitle-1 mb-2">Summary of Mezzofy Vouchers for Birthday/LSA Vouchers</h2>
    <AppDataTable :columns="summaryColumns" :rows="summaryRows" :loading="loading" row-key="id" empty-text="No Mezzofy voucher data." class="mb-6" />

    <h2 class="text-subtitle-1 mb-2">Available Vouchers Breakdown</h2>
    <AppDataTable :columns="availableColumns" :rows="availableRows" :loading="loading" row-key="id" empty-text="No available voucher data." />
  </section>
</template>
